export default {
  main: {
    jp: 'なかたくらぼ',
    en: 'Naka Taku Lab',
  },
  sub: {
    jp: '某神大情報系M1の研究とかまとめ',
    en: "Summary of Nakata's research",
  },
  history: { jp: '更新履歴', en: 'Update History' },
  photo: { jp: '写真', en: 'Photo' },
  profile: { jp: 'プロフィール', en: 'Profile' },
  research: { jp: '研究', en: 'Research' },
  url: { jp: 'リンク', en: 'Link' },
}
